/* Dock Rats: progressive motion, considered signup and complementary purchases. */
(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const rootURL = () => (window.Shopify?.routes?.root || window.themeStrings?.routesRoot || '/').replace(/\/?$/, '/');
  const session = {
    get(key) { try { return sessionStorage.getItem(key); } catch { return null; } },
    set(key, value) { try { sessionStorage.setItem(key, value); } catch { /* Session storage is optional. */ } }
  };
  // Only secondary sections are revealed; the hero and product details stay visible at first paint.
  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('dr-revealed');
      revealObserver.unobserve(entry.target);
    });
  }, {threshold: 0.06, rootMargin: '0px 0px -24px 0px'}) : null;
  function motion(scope) {
    if (!revealObserver || reduced.matches || document.body.dataset.motionEnabled !== 'true') return;
    $$('.collection-tile, .image-text__content, .fit-guide__item, .journal-feature__row', scope).forEach((el, i) => {
      if (el.dataset.drReveal !== undefined) return;
      el.dataset.drReveal = '';
      if (el.getBoundingClientRect().top < window.innerHeight) { el.classList.add('dr-revealed'); return; }
      el.style.setProperty('--reveal-delay', `${(i % 3) * 45}ms`);
      revealObserver.observe(el);
    });
  }
  document.addEventListener('focusin', event => event.target.closest('[data-dr-reveal]')?.classList.add('dr-revealed'));
  reduced.addEventListener('change', () => { if (reduced.matches) $$('[data-dr-reveal]').forEach(el => el.classList.add('dr-revealed')); });
  window.addEventListener('pageshow', event => { if (event.persisted) $$('[data-dr-reveal]').forEach(el => el.classList.add('dr-revealed')); });
  function stickyBuy(scope) {
    $$('[data-product-root]', scope).forEach(root => {
      const bar = $('[data-sticky-buy]', root), primary = $('.product-buy-box [data-add-button]', root);
      if (!bar || !primary || bar.dataset.ready || !('IntersectionObserver' in window)) return;
      bar.dataset.ready = 'true';
      let pastButton = false, footerVisible = false;
      const update = () => { bar.hidden = !pastButton || footerVisible; };
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.target === primary) pastButton = !entry.isIntersecting && entry.boundingClientRect.bottom < 90;
          else footerVisible = entry.isIntersecting;
        });
        update();
      }, {rootMargin: '-90px 0px 0px 0px'});
      observer.observe(primary);
      const footer = $('.site-footer'); if (footer) observer.observe(footer);
    });
  }
  // Browser-native validation ensures a variant is selected before the existing Ajax add handler runs.
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-pairing-variant]');
    if (!select) return;
    const option = select.selectedOptions[0], card = select.closest('[data-pairing-card]');
    if (!option?.value || !card) return;
    $('[data-pairing-price]', card).textContent = option.dataset.price;
    $$('[data-pairing-link]', card).forEach(link => { link.href = option.dataset.url; });
    const image = $('.pairing-card__image img', card);
    if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
  });
  let pairingController, pairingSequence = 0;
  document.addEventListener('cart:updated', async event => {
    const slot = $('[data-cart-upsell]'); if (!slot) return;
    pairingController?.abort();
    const sequence = ++pairingSequence;
    if (!event.detail?.item_count || $('[data-club-header]') || document.body.className.includes('template-suffix-kkva')) { slot.replaceChildren(); return; }
    pairingController = new AbortController();
    try {
      const response = await fetch(`${rootURL()}cart?sections=cart-pairings`, {signal: pairingController.signal});
      if (!response.ok) return;
      const sections = await response.json();
      if (sequence !== pairingSequence) return;
      const fragment = new DOMParser().parseFromString(sections['cart-pairings'] || '', 'text/html');
      const content = fragment.querySelector('.cart-pairings');
      if (content) {
        // The cart page and drawer may show the same section; labels must retain unique targets.
        $$('[id]', content).forEach(el => el.setAttribute('id', 'Drawer-' + el.getAttribute('id')));
        $$('[for]', content).forEach(el => el.setAttribute('for', 'Drawer-' + el.getAttribute('for')));
      }
      slot.replaceChildren(...(content ? [content] : []));
    } catch (error) { if (error.name !== 'AbortError' && sequence === pairingSequence) slot.replaceChildren(); }
  });
  function newsletter(scope) {
    const dialog = $('[data-newsletter-popup]', scope);
    if (!dialog || dialog.dataset.ready || typeof dialog.showModal !== 'function') return;
    dialog.dataset.ready = 'true';
    $$('[data-newsletter-open]').forEach(button => { button.hidden = false; });
    const app = $('[data-newsletter-app]', dialog);
    const fallback = $('[data-newsletter-fallback]', dialog);
    if (app && fallback) {
      let observedRoot;
      const observer = new MutationObserver(syncForm);
      function syncForm() {
        const shadow = $('shopify-forms-embed', app)?.shadowRoot;
        if (shadow && shadow !== observedRoot) {
          observedRoot = shadow;
          observer.observe(shadow, {childList: true, subtree: true});
        }
        if (!shadow?.querySelector('form')) return;
        if (fallback.contains(document.activeElement) || $('input[type="email"]', fallback)?.value) return;
        fallback.hidden = true;
        app.hidden = false;
        dialog.dataset.formsReady = 'true';
        observer.disconnect();
        dialog.dispatchEvent(new CustomEvent('dr:newsletter-ready'));
      }
      observer.observe(app, {childList: true, subtree: true});
      syncForm();
    }
    const seenKey = 'dr-newsletter-seen-v1';
    const nextKey = 'dr-newsletter-next-show-v2';
    const subscribedKey = 'dr-newsletter-subscribed-until-v2';
    const day = 86400000;
    const cooldown = Math.max(7, Number(dialog.dataset.cooldown || 30)) * day;
    let storageAvailable = true;
    const read = key => { try { return Number(localStorage.getItem(key) || 0); } catch { storageAvailable = false; return 0; } };
    const write = (key, value) => { try { localStorage.setItem(key, String(value)); } catch { storageAvailable = false; } };
    let nextShow = read(nextKey);
    let subscribedUntil = read(subscribedKey);
    try { localStorage.setItem('dr-newsletter-storage-check', '1'); localStorage.removeItem('dr-newsletter-storage-check'); } catch { storageAvailable = false; }
    const result = $('[data-newsletter-result]', dialog);
    const url = new URL(location.href);
    if (result?.dataset.newsletterResult === 'success' || url.searchParams.get('dr_newsletter') === 'complete') {
      subscribedUntil = Date.now() + 365 * day;
      write(subscribedKey, subscribedUntil);
      if (url.searchParams.has('dr_newsletter')) {
        url.searchParams.delete('dr_newsletter');
        history.replaceState(history.state, '', url.pathname + url.search + url.hash);
      }
    }
    let opener, shown = session.get(seenKey) === '1';
    function open(manual = false) {
      if (!dialog.isConnected || dialog.open || document.body.classList.contains('drawer-open') || $('dialog[open]')) return false;
      if (!manual && (document.activeElement?.matches('input,select,textarea') || document.hidden)) return false;
      opener = document.activeElement;
      dialog.showModal();
      document.body.classList.add('newsletter-open');
      $('[data-newsletter-close]', dialog)?.focus();
      shown = true; session.set(seenKey, '1');
      nextShow = Date.now() + cooldown; write(nextKey, nextShow);
      return true;
    }
    dialog.addEventListener('close', () => { document.body.classList.remove('newsletter-open'); opener?.focus(); });
    $('[data-newsletter-close]', dialog)?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('dr:newsletter-open', () => open(true));
    if (result && location.hash === '#NewsletterPopupForm') open(true);
    if (dialog.dataset.auto !== 'true' || window.Shopify?.designMode || !storageAvailable || shown || nextShow > Date.now() || subscribedUntil > Date.now()) return;
    function scheduleAutomaticOpen() {
      window.setTimeout(() => {
        if (dialog.dataset.formsReady === 'true' && !shown && read(nextKey) <= Date.now() && read(subscribedKey) <= Date.now()) open();
      }, Number(dialog.dataset.delay || 10) * 1000);
    }
    if (dialog.dataset.formsReady === 'true') scheduleAutomaticOpen();
    else dialog.addEventListener('dr:newsletter-ready', scheduleAutomaticOpen, {once: true});
  }
  document.addEventListener('click', event => {
    if (event.target.closest('[data-newsletter-open]')) $('[data-newsletter-popup]')?.dispatchEvent(new CustomEvent('dr:newsletter-open'));
  });
  function relatedProducts(scope) {
    $$('[data-related-products]', scope).forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const track = $('[data-related-track]', section), controls = $('[data-related-controls]', section);
      if (!track || !controls) return;
      const previous = $('[data-related-direction="-1"]', controls), next = $('[data-related-direction="1"]', controls);
      function update() {
        const end = track.scrollWidth - track.clientWidth;
        controls.hidden = end < 2;
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft >= end - 2;
      }
      $$('[data-related-direction]', controls).forEach(button => button.addEventListener('click', () => {
        const card = track.firstElementChild;
        const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap) : track.clientWidth;
        track.scrollBy({left: Number(button.dataset.relatedDirection) * step, behavior: reduced.matches ? 'instant' : 'smooth'});
      }));
      track.addEventListener('scroll', update, {passive: true});
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
      // Server-rendered fallback remains usable if recommendations are unavailable.
      if (!('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver(async entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        observer.disconnect();
        try {
          const response = await fetch(section.dataset.url);
          if (!response.ok || !section.isConnected) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = $('[data-related-track]', html);
          if (!incoming?.children.length || track.contains(document.activeElement) || track.scrollLeft > 0) return;
          track.replaceChildren(...incoming.children);
          update();
        } catch { /* Keep the existing product links. */ }
      }, {rootMargin: '0px 0px 400px 0px'});
      observer.observe(section);
    });
  }
  function init(scope = document) { relatedProducts(scope); motion(scope); stickyBuy(scope); newsletter(scope); }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
